<template>
  <div class="CheckDiary">
    <div class="status">
      <el-button style="margin-right: 100px" type="primary"   size="small" >数据刷新时间：{{updateTime}}</el-button>
      <el-button type="primary" size="small" @click="getDiary">刷新</el-button>
    </div>
    <div class="search">
        <span class="wordFind">查找：</span>
        <el-input class="find" v-model="search" size="mini" placeholder="请输入关键字"></el-input>
        <span class="wordPage">选择每页显示的行数：</span>
        <el-select v-model="value" class="page" size="mini">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
        </el-select>
    </div>
    <div class="statusTable">
      <el-table
        :data="diarysTable.slice((currentPage - 1) * value, currentPage * value)"
        height="100%">
        <el-table-column
            type="index"
            width="80px"
            label="序号"
        >

        </el-table-column>
        <el-table-column
        prop="checkStartTime"
        label="上一次巡检开始时间"
        sortable>
        </el-table-column>

        <el-table-column
        prop="checkEndTime"
        label="上一次巡检结束时间"
        sortable>
        </el-table-column>

        <el-table-column
        prop="checkSpendTime"
        label="上一次巡检花费时间"
        sortable>
        </el-table-column>

        <el-table-column
        prop="equipNum"
        label="设备数目"
        sortable>
        </el-table-column>
        
        <el-table-column
        prop="pointNum"
        label="测点数目"
        sortable>
        </el-table-column>

        <el-table-column
        prop="errorNum"
        label="异常数目"
        sortable>
        </el-table-column>
        <!-- <el-table-column
        prop="status"
        label="实时状态"
        width="150px"
        sortable> -->
          <!-- <template #default="scope">
            <el-tooltip
                class="box-item"
                effect="light"
                :key="scope.row.id"
                :enterable="false"
                :disabled="(scope.row.status.indexOf('报警数据无波形') === -1 || scope.row.note === '' || scope.row.note === null)"
                :content="scope.row.note"
                placement="top"
            > -->
            <!-- 换行显示方法 -->
            <!-- <template #content><div v-html="scope.row.note"></div></template>
              <span style="cursor: pointer;">{{ scope.row.status }}</span>
            </el-tooltip>

          </template> -->
        <!-- <el-table-column
        label="实时状态"
        width="150px"
        sortable>
        <template #default="scope">
            <el-button @click="showAlarmNoWavedialog(scope.$index, scope.row)"  type="text" >{{scope.row.status}}</el-button>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
        label="确认状态"
        width="70px">
        <template #default="scope">
          <div v-if="scope.row.isConfirm==0">
            <el-button @click="updateIsConfirm(scope.row)"  type="text" >未确认</el-button>
          </div>
          <div v-else>
            <el-button @click="updateIsConfirm(scope.row)"  type="text" style="color:green;">已确认</el-button>
          </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <el-pagination
        layout="prev, pager, next"
        :total="(diarysTable.length / value) * 10"
        @current-change="handleCurrentChange"
        :current-page="currentPage"></el-pagination>
  </div>
</template>

<script>
import {ref, onBeforeMount, computed, watch,onMounted} from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import {useStore} from 'vuex'
import {export_json_to_excel} from "../components/ExportFiles/Export2Excel";
import {useRoute} from 'vue-router'
import axios from 'axios'
import {
  Iphone,
  Location,
  OfficeBuilding,
  Tickets,
  User,
} from '@element-plus/icons-vue'
export default {
  name: 'CheckDiary',
  components:{
    Iphone,Location,OfficeBuilding,Tickets,User,
  },
  setup(props, ctx){
    const iconStyle = computed(() => {
        return {
          marginRight: '20px',
        }
    })
    let tableData = ref([]);
    let search = ref('');
    let value = ref(10);
    let totalNum = ref(0);
    let currentPage = ref(1);
    let handleCurrentChange = ((val) => {
        currentPage.value = val;
    })
    let options = ref([
          {
              value: 10,
              label: 10
          },
          {
              value: 15,
              label: 15
          },
          {
              value: 25,
              label: 25
          },
          {
              value: 50,
              label: 50
          },
          {
              value: 100,
              label: 100
          }
    ])
    let updateTime=ref('')
    let getDiary = (() => {
      //var url="/api1/data/diary"
      updateTime.value=timestampToTime(new Date().valueOf())
      axios.get('/api1/data/diary').then(res=>{
        //console.log('res_diary',res);
        let diarys = res.data.data;
        console.log("diarys",diarys);
        for(let i=0;i<diarys.length;i++)
        {
          // console.log('i',diarys.value[i]);
          diarys[i].checkSpendTime=diarys[i].checkEndTime-diarys[i].checkStartTime
          diarys[i].checkStartTime=timestampToTime(diarys[i].checkStartTime)
          if(diarys[i].checkEndTime==0){
            diarys[i].checkEndTime='巡检暂未完成'
            diarys[i].checkSpendTime='巡检暂未完成'
          }else if(diarys[i].checkEndTime==-1){
            diarys[i].checkEndTime='未获取到中间件数据，巡检中止'
            diarys[i].checkSpendTime='未获取到中间件数据，巡检中止'
          }else{
            diarys[i].checkEndTime=timestampToTime(diarys[i].checkEndTime)
            diarys[i].checkSpendTime=(Math.floor(diarys[i].checkSpendTime/(1000*60*60)))+"小时"+(Math.floor(diarys[i].checkSpendTime/(1000*60)%60)+"分钟")
          }
          // diarys[i].checkEndTime=(diarys[i].checkEndTime==0?'巡检暂未完成':timestampToTime(diarys[i].checkEndTime))
          // diarys[i].checkSpendTime=(diarys[i].checkSpendTime==0?'巡检暂未完成':(diarys[i].checkSpendTime/(1000*60)).toFixed(2)+"分钟")
          // diarys[i].checkSpendTime=(diarys[i].checkSpendTime==0?'巡检暂未完成':(Math.floor(diarys[i].checkSpendTime/(1000*60*60)))+"小时"+(Math.floor(diarys[i].checkSpendTime/(1000*60)%60)+"分钟"))
        }
        
        //去掉diarys第一列元素
        diarys.shift()
        // ElMessage({
        //     message: '巡检日志获取成功.',
        //     type: 'success',
        //   })
        tableData.value = diarys;
        totalNum.value = tableData.value.length;
      })
    })
    let diarysTable = computed(() => {
        let input = search.value && search.value.toLowerCase();
        let items = tableData.value;
        let items1;
        if (input) {
            items1 = items.filter((item) => {
                return Object.keys(item).some((key1) => {
                    return String(item[key1])
                        .toLowerCase()
                        .match(input);
                })
            })
        } else {
            items1 = items;
        }
        // items1.sort((a, b) => {
        //   return a.sendTime > b.sendTime
        // })
        return items1;
    })
    let dataTableUpdataTime=ref("00-00-00")
    onMounted(()=>{
      getDiary();
    })
    let timestampToTime = (timestamp) => {
      let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '';
      let ms = (timestamp % 1000).toString()
      while (ms.length < 3) {
        ms = '0' + ms
      }
      return Y + M + D + h + m + s ;
    }
    return {
      iconStyle,
      diarysTable,
      search,
      value,
      totalNum,
      tableData,
      currentPage,
      options,
      handleCurrentChange,
      getDiary,
      updateTime,
      dataTableUpdataTime,
      timestampToTime
    }
  }
}
</script>

<style lang="scss">
  .CheckDiary{
    // --borderColor: #dcdfe6;
    width: 100%;
    height: calc(100vh - 60px);
    margin-right: 10px;
    // margin-bottom: 10px;
    background-color: #303749;
    // background-color: #bfa;
    .status{
      height: 7%;
      background-color: #2c3242;
      margin-left: 10px;
      margin-right: 10px;
      margin-top: 10px;
      .el-menu{
        height: 100%;
        background-color: #2c3242;
        border-bottom: 0px;
        display: flex;
        align-items: center; //垂直居中
        // justify-content: center;
        .el-menu-item.hItem{
          font-size: 20px;
        }
        .el-menu-item{
          color: #fff;
          font-size: 13px;
          border-bottom: 0px;
        }
        .el-menu-item.is-active{
          background-color: #2c3242 !important;
          color: #359186;
          border-bottom: 0px;
        }
        .el-menu-item.hItem.is-active{
          background-color: #2c3242 !important;
          color: #fff !important;
          border-bottom: 0px;
        }
        .el-menu-item:hover{
          background-color: #2c3242 ;
          color: #359186;
        }
        .el-menu-item.hItem:hover{
          background-color: #2c3242;
          color: #fff;
        }
      }
      .el-button:hover{
        border-color: #42b983;
        color: #42b983;
      }
      .el-button{
        background-color: #2C3242;
        border-color: #fff;
        position: absolute;
        margin-top: 10px;
        right: 30px;
      }
    }
    .choose{
      height: 6%;
      margin: 0 10px;
      background-color: #2c3242;
      display: flex;
      align-items: center;
      span{
        font-size: 13px;
        color: #fff;
        margin-left: 10px;
      }
      .el-select .el-input {
        .el-input__inner{
          background-color: #2c3242;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-button{
        margin-left: 10px;
        background-color: #2c3242;
        span{
          margin: 0px;
        }
      }
    }
    .search{
      display: flex;
      margin: 0px 10px;
      position: relative;
      align-items: center;
      span{
        margin-top: 10px;
        font-size: 13px;
        color: #fff;
      }
      span.wordFind{
        margin-left: 5px;
      }
      .el-input{
        // margin-left: 10px;
        margin-top: 10px;
        width: 200px;
        .el-input__inner{
          background-color: #303749;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-input .el-input__inner.active{
        border: 1px red solid;
      }
      .el-select .el-input{
        width: 100px;
        .el-input__inner{
          text-align: center;
          border: 1px #fff solid;
        }
        .el-input__suffix, .el-input__suffix-inner{
          margin-top: 0px;
        }
      }
      span.wordPage{
        position: absolute;
        right: 100px;
      }
      .el-select.page{
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .statusTable{
      margin-left: 10px;
      margin-right: 10px;
      background-color: #2c3242;
      height: 66%;    
      .descriptions {
        .el-descriptions__label.el-descriptions__cell.is-bordered-label
        {
          background-color: #252937;
          color: white;
        }
        .el-descriptions__content{
          background-color: #2c3242;
          color: white;
        }
        // .el-descriptions {
        //   margin-top: 20px;
        // }
        .cell-item {
          display: flex;
          align-items: center;
        }
        }
      //去除表格最下面那条线
      .el-table::before{
        height: 0px;
      }
      .el-table{
        background-color: #2c3242;
        //去除表头下面那条线
        th.el-table__cell.is-leaf{
          border-bottom: 0px;
        }
        //设置排序图标的颜色
        // .descending .sort-caret.descending {
        //   border-top-color: #359186;
        // }
        // .ascending .sort-caret.ascending {
        //   border-bottom-color: #359186;
        // }
        .cell{
          text-align: center;
        }
        th{
          background-color: #2c3242;
          color: #fff;
          // border-right: 1px solid rgba(256, 256, 256, 0.5);
        }
        tr{
          background-color: #2c3242;
          color: #fff;
          td{
            border-bottom: 0px;
          }
        }
        tr:hover td{
          background-color: rgba(107, 199, 255, 0.98) !important;
        }
      }
    }
    .el-pagination{
      margin-top: 10px;
      display: flex;
      align-items: center; //垂直居中
      ul li{
        background-color: #303749;
        color: #fff;
      }
      ul li.active{
        color: #359186;
      }
      ul li:hover{
        color: #359186;
      }
      .btn-prev{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
      .btn-next{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
    }
    .rule{
      background-color: #303749;
      color: #fff;
    }

    .el-dialog{
      text-align: left;
      width: 70vh;
      // height: 60vh;
      .el-input{
        width: 222px;
        .el-input__inner:hover{
          border: 1px solid #409eff;
        }
      }
      .inputMail .el-input__inner{
        border: 1px v-bind(borderColor1) solid;
      }
      // .inputMail .el-input__inner:hover{
      //   border: 1px #c0c4cc solid;
      // }
      .inputUser .el-input__inner{
        border: 1px v-bind(borderColor2) solid;
      }
      // .inputUser .el-input__inner:hover{
      //   border: 1px #c0c4cc solid;
      // }
      .el-form-item.slider .el-form-item__content{
        display: flex;
        span{
          margin-left: 12px;
          font-size: 13px;
        }
      }
       .el-slider, .el-slider__runway{
          width: 220px;
        }
    }
  }
</style>
